import FingerprintJS from '@fingerprintjs/fingerprintjs'

let fingerprintPromise = null

/**
 * 获取浏览器指纹（缓存结果，同一浏览器始终返回相同值）
 * @returns {Promise<string>} 指纹哈希值
 */
export async function getFingerprint() {
  if (!fingerprintPromise) {
    fingerprintPromise = FingerprintJS.load()
      .then(fp => fp.get())
      .then(result => result.visitorId)
      .catch(err => {
        console.error('获取浏览器指纹失败:', err)
        // 降级：生成随机值（仅本次会话有效，刷新后变化）
        fingerprintPromise = null
        return 'fp_fallback_' + Math.random().toString(36).substring(2)
      })
  }
  return fingerprintPromise
}
